import React from "react";
import { FaTrophy, FaStar } from "react-icons/fa";
import styles from "./AwardPage.module.css";

const AwardPage = () => {

    return (
        <main className={styles.mainContent}>
            <div className={styles.comingSoonCard}>
                <div className={styles.iconContainer}>
                    <FaTrophy className={styles.trophyIcon} />

                    <FaStar className={`${styles.starIcon} ${styles.starOne}`} />
                    <FaStar className={`${styles.starIcon} ${styles.starTwo}`} />
                    <FaStar className={`${styles.starIcon} ${styles.starThree}`} />
                </div>

                <h1 className={styles.title}>
                    Awards & Recognition
                </h1>

                <p className={styles.subtitle}>
                    Our awards showcase and submission details will be
                    launching soon. Stay tuned!
                </p>

                <div className={styles.badge}>
                    Coming Soon 2026
                </div>
            </div>

        </main>
    );
};

export default AwardPage;